import { getRandomFromList } from '../../../../../utils/data/random/getRandomFromRange';

const initialState = {
  wishes: getInitialState(),
};

const reducers = {
  setWishDataName(state, { payload: { name } }) {
    state.wishes.data.name = name;
    state.wishes.data.text = getRandomFromList(state.wishes.texts);
  },
  setWishDataImage(state, { payload: { image } }) {
    state.wishes.data.image = image;
  },
  setWishDataElf(state, { payload: { elf } }) {
    state.wishes.data.elf = elf;
  },
  setWishSwiper(state, { payload: swiper }) {
    state.wishes.swiper = swiper;
  },
  setWishElfSwiper(state, { payload: swiper }) {
    state.wishes.elfSwiper = swiper;
  },
  setWishStep(state, { payload: step }) {
    state.wishes.step = step;
  },
  setWishErrorName(state, { payload: { name } }) {
    state.wishes.errorNames = [...state.wishes.errorNames, name];
    state.wishes.defaultValue = name;
  },
  resetWishData(state) {
    state.wishes.data = getInitialWishData();
    state.wishes.defaultValue = '';
    state.wishes.step = 0;
    state.wishes.elfSwiper = null;
  },
};

const matchers = [
  [
    ({ type }) => type === 'requests/game/get-index/fulfilled',
    (state, { payload: { wishes, wishTexts } }) => {
      state.wishes.images = wishes.map(({ id, is_black_text, background, elf1, elf2, elf3 }) => ({
        id,
        is_black_text,
        image: background,
        elf1,
        elf2,
        elf3,
      }));
      state.wishes.texts = wishTexts;
    },
  ],
  [
    ({ type }) => type === 'requests/wish-get/fulfilled',
    (state, { payload }) => {
      if (payload?.wishes && payload?._meta)
        state.wishes.donatedWishes = {
          list: payload.wishes,
          count: payload._meta.totalCount,
        };
    },
  ],
];

export const wishSegment = {
  initialState,
  reducers,
  matchers,
};

function getInitialState() {
  return {
    id: null,
    step: 0,
    texts: [],
    images: [],
    swiper: null,
    elfSwiper: null,
    errorNames: [],
    defaultValue: '',
    data: getInitialWishData(),
    donatedWishes: getInitialDonatedWishes(),
  };
}

function getInitialWishData() {
  return {
    image: null,
    elf: null,
    name: null,
    text: null,
  };
}

function getInitialDonatedWishes() {
  return { list: [], count: 0 };
}
